// extracted by mini-css-extract-plugin
export default {"sourceContainer":"ajuJLTZQrCq_qeSeXPgU","fieldLabel":"epwfn7rIRRjfE9jSvqgD rhD9z6GfLzBBqZsf_Jx2","sourceText":"fXSxrOeDS3qViUyEFBxg"};